import { DestroyRef, inject, Injector } from "@angular/core";
import { FrontendAccessServiceProvider } from "@core/frontend-shared";
import { FormStateService } from "@common/forms/shared";
import { AppMessageFactory } from "@core/frontend-shared";
import { ModelFactoryProvider } from "@core/shared/model";
import { ModelFormService } from "./model-form.service";
import { DynamicFormBuilder } from '../dynamic-form-group';
import * as i0 from "@angular/core";
;
export function modelFormServiceFactoryDepsToCtorArgs(d) {
  return [d.dfb, d.formStateService, d.message, d.modelFactoryProvider, d.destroyRef, d.injector];
}
export function modelFormServiceFactoryFacade(deps) {
  return {
    createModelForm(ModelConstructor) {
      const fs = new ModelFormService(...modelFormServiceFactoryDepsToCtorArgs(deps));
      fs.setModel(ModelConstructor);
      return fs;
    },
    // NOTE: commented as no code is using these methods atm.
    // createInstructionForm<T = any>():InstructionFormService<T>
    // {
    // 	const fs = new InstructionFormService<T>(...ctorArgs);
    // 	return fs;
    // },
    // createCustomFormService<T extends Model, TClass extends BaseFormService<T>>(
    // 	ClassConstructor:new(...args:BaseFormServiceCtorArgs)=>BaseFormService<any,any>,
    // 	ModelConstructor:new()=>T,
    // ):TClass
    // {
    // 	const fs = new (ClassConstructor)(...ctorArgs);
    // 	fs.setModel(ModelConstructor as any)
    // 	return fs as TClass;
    // },
    createUninitialized(ClassConstructor) {
      if (typeof ClassConstructor === 'undefined') {
        return new ModelFormService(...modelFormServiceFactoryDepsToCtorArgs(deps));
      }
      return new ClassConstructor(...modelFormServiceFactoryDepsToCtorArgs(deps));
    }
  };
}
export let ModelFormServiceFactory = /*#__PURE__*/(() => {
  class ModelFormServiceFactory {
    constructor() {
      this.deps = {
        dfb: inject(DynamicFormBuilder),
        formStateService: inject(FormStateService),
        accessProvider: inject(FrontendAccessServiceProvider),
        message: inject(AppMessageFactory),
        modelFactoryProvider: inject(ModelFactoryProvider),
        injector: inject(Injector),
        destroyRef: inject(DestroyRef)
      };
      this.fallback = modelFormServiceFactoryFacade(this.deps);
    }
    useDestroyRef(destroyRef) {
      return modelFormServiceFactoryFacade({
        ...this.deps,
        destroyRef
      });
    }
    static {
      this.ɵfac = function ModelFormServiceFactory_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ModelFormServiceFactory)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: ModelFormServiceFactory,
        factory: ModelFormServiceFactory.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ModelFormServiceFactory;
})();